import { render, staticRenderFns } from "./ParamsRight.vue?vue&type=template&id=0b6d2bd1&scoped=true"
import script from "./ParamsRight.vue?vue&type=script&lang=js"
export * from "./ParamsRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d2bd1",
  null
  
)

export default component.exports